import Audit2 from '@assets/images/img-final-audit-02.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './AuditFive.style';
import { useTranslation } from 'react-i18next';

const AuditFive = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditFive.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <div className="text-content">
            <p>
              {t('auditFive.paragraph.spanBefore')}
              <span>2</span>
              {t('auditFive.paragraph.spanAfter')}
            </p>
          </div>
        </TextBox2>

        <TextBox2>
          <ul>
            <li>{t('auditFive.ul.liOne')}</li>
            <li>{t('auditFive.ul.liTwo')}</li>
            <li>{t('auditFive.ul.liThree')}</li>
          </ul>
        </TextBox2>
        <ImageBox>
          <img src={Audit2} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditFive;
